<div class="liveCasino" *ngIf="this._UserHelper?.isSignedIn">
  <button mat-stroked-button *ngFor="let item of gameTypes" (click)="handleGameTypeChange(item)">{{ item }}</button>

  <div class="cardsMainContainer">
    <div class="cardItem" *ngFor="let item of this.casinoList" (click)="openGame(item)">
      <p class="largeHead company">{{ item.company }}</p>
      <img src="{{ item.dealerImageUrl }}" alt="{{ item.dealerName }}" />
      <div class="bottomArea">
        <div class="names">
          <p class="largeHead">{{ gameNameByID[item.gameType] }}</p>
          <p class="smallText">{{ item.dealerName }}</p>
        </div>
        <div class="onlineStatus">
          <p class="onlineIcon {{ item.isOpen === 0 ? 'isOffline' : '' }} {{ item.isOpen === 1 ? 'isOnline' : '' }}"></p>
        </div>
      </div>
    </div>
  </div>
</div>
